export default __webpack_public_path__ + "static/media/120.0b19b881.png";